import { createQueryKeys } from "@lukemorales/query-key-factory";
import { z } from "zod";

import { createServiceResponseSchema, privateApi } from "@/api/axios";
import { productLabResultSchema } from "@/domains/products/models/schemas";

export const productsQueryOptions = createQueryKeys("products", {
  "lab-results": {
    queryKey: null,
    queryFn: () => {
      return getLabResults();
    },
  },
});

export const getLabResults = async () => {
  const response = await privateApi.get("/products/labs-results?page=1&perPage=100");

  return createServiceResponseSchema(z.array(productLabResultSchema)).parse(response.data).data;
};
